import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import DefaultLayout from "../../layouts/DefaultLayout";
import { withRouter } from "react-router-dom";
import { Button, Card, Col, Input, Row, Table } from "antd";
import { debounce } from "lodash";
import EditableTableCell from "../../table/EditableTableCell";
import { defaultCurrencyFormat } from "../../../utilities";
import { NotRenewingReasonPicker } from "../../ui/forms/NotRenewingReasonPicker";

/**
 * Shows renewals for quotes.
 */
@inject("context")
@withRouter
@observer
class Renewals extends Component {
	componentDidMount() {
		this.reloadRenewals();
	}

	render() {
		const service = this.props.context.renewalsService;

		const columns = [
			{
				title: "Renewal date",
				dataIndex: "startDate",
				sorter: true,
				defaultSortOrder: "descend",
				render: (date) => {
					return new Date(date).toLocaleDateString();
				},
			},
			{
				title: "Policy number",
				dataIndex: "policyNumber",
				sorter: true,
			},
			{
				title: "First name",
				dataIndex: "first_name",
			},
			{
				title: "Last name",
				dataIndex: "last_name",
				sorter: true,
			},
			{
				title: "Renewal premium",
				dataIndex: "renewalPremium",
				render: (n) => {
					return defaultCurrencyFormat(n);
				},
			},
			{
				title: "Phone number",
				dataIndex: "phoneNumber",
			},
			{
				title: "Address 1",
				dataIndex: "address1",
			},
			{
				title: "Address 2",
				dataIndex: "address2",
			},
			{
				title: "City",
				dataIndex: "address4",
			},
			{
				title: "Postcode",
				dataIndex: "postcode",
			},
			{
				title: "Actions",
				render: (field, record) => {
					return (
						<Button
							type="primary"
							onClick={() => this.handleRenewButtonClick(record)}
						>
							Renew
						</Button>
					);
				},
			},
			{
				title: "Not renewing reason",
				dataIndex: "notRenewingReason",
				render: (notRenewingReason, record) => {
					return (
						<NotRenewingReasonPicker
							value={notRenewingReason || ""}
							onChange={(value) =>
								this.handleNotRenewingReasonChange(value, record.quoteId)
							}
						/>
					);
				},
			},
			{
				title: "Notes",
				dataIndex: "notes",
				width: "30%",
				render: (notes, record) => {
					return (
						<EditableTableCell
							recordId={record.quoteId}
							handleSave={this.handleSaveQuoteNotesClick}
							value={notes}
						/>
					);
				},
			},
		];

		return (
			<DefaultLayout
				layoutContentProps={{
					style: {
						maxWidth: "100%",
						paddingLeft: 40,
						paddingRight: 40,
					},
				}}
			>
				<Row>
					<Col xs={24}>
						<Card title={<h1>Renewals</h1>}>
							<Row>
								<Col
									xs={6}
									style={{
										paddingBottom: "15px",
									}}
								>
									<Input.Search
										onSearch={this.handleSearchChange}
										onChange={this.handleSearchChange}
										value={service.search.value}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<Table
										rowKey="quoteId"
										columns={columns}
										dataSource={service.renewalsData}
										pagination={service.pagination}
										loading={service.loading}
										onChange={this.handleTableChange}
									/>
								</Col>
							</Row>
						</Card>
					</Col>
				</Row>
			</DefaultLayout>
		);
	}


	handleTableChange = (pagination, filters, sorter) => {
		const service = this.props.context.renewalsService;

		service.setPagination(pagination);
		service.setSorter(sorter);

		service.loadRenewalsData();
	};

	handleSearchChange = (...args) => {
		const value =
			args.length === 2
				? args[1].currentTarget.value
				: args[0].currentTarget.value;

		this.props.context.renewalsService.setSearch({
			fields: [
				"policyNumber",
				"organisation.last_name",
				"organisation.post_code",
			],
			value,
		});

		this.debouncedReloadItems();
	};

	handleNotRenewingReasonChange = async (value, quoteId) => {
		const { renewalsService } = this.props.context;
		await renewalsService.updateQuoteNotRenewingReason(value, quoteId);
		this.reloadRenewals();
	};

	handleRenewButtonClick = async (record) => {
		const { quoteId } = record;

		if (quoteId) {
			this.props.context.insuranceRenewalsService.setOverThePhone(true);
			this.props.context.insuranceRenewalsService.setClientData({ comingFromRenewalsPage: true });

			this.props.history.push(`/renew/${quoteId}`);
		}

		console.log("this.props.context.setClientData", this.props.context.insuranceRenewalsService.clientData);
	};

	handleSaveQuoteNotesClick = async (quoteId, notes) => {
		await this.props.context.renewalsService.saveQuoteNotes(quoteId, notes);
		this.reloadRenewals();
	};

	reloadRenewals = async () => {
		await this.props.context.renewalsService.loadRenewalsData();
	};

	debouncedReloadItems = debounce(this.reloadRenewals, 250);
}

export default Renewals;
